import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet'
import Product from "../../templates/common/product";
import { connect } from 'react-redux'
import dispatch from '../../templates/store';
import {getOrLoginUser, logoutUser, addToCart} from '../../templates/actions'
import HeaderOne from "../../templates/common/headers/header-one";
import {Link} from "react-router-dom";
import 'react-responsive-modal/styles.css';
import "./style.css"
import { useParams } from "react-router-dom";

const axios = require('axios');

const ProductPage = (props) => {
    const { product_slug } = useParams();
    const [product, setProduct] = useState({});
    const [domain, setDomain] = useState("");
    const [approvedDomain, setApprovedDomain] = useState(false);

    useEffect(() => {
        setProduct(props.products.find(el => el.slug == product_slug));
    });

    const onChange = (e) => {
        setDomain(e.target.value);
    };

    const addToCart = () => {
        props.addToCart(product, props.cart ? props.cart.id : null);
    }

    const searchDomainAvailable = () => {
        let request = new Request("https://api.sandbox.namecheap.com/xml.response",
            {
                method: 'POST',
                body: {
                    ApiUser: 'domainsandchai',
                    UserName: 'domainsandchai',
                    ApiKey: 'f16eb477cbc64dd89f7897a6534a82fd',
                    ClientIP: '75.69.162.139',
                    Command: 'namecheap.domains.check',
                    DomainList: domain
                }
            }
        )
        fetch(request).
        then(data => {
            console.log(data.json());
        }).catch(error => {
            console.log(error);
        })
    }

    return (
        <div>
            {/*SEO Support*/}
            <Helmet>
                <title>Biscuit & Chai</title>
                <meta name="description" content="Brewing Thoughtfully Designed Products" />
            </Helmet>
            {/*SEO Support End */}

            <HeaderOne storeName="Biscuit & Chai" />

            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="product-box">
                            <div role="button" tabIndex={0} aria-label={`View ${product.name} Details`} className="img-wrapper text-center">
                                <div className="front">
                                    <img
                                        src={`https://biscuitandchai-general.nyc3.cdn.digitaloceanspaces.com/biscuitandchai/${product.slug}.png`}
                                        className="img-fluid product-listing-box-image"
                                        alt={`${product.name}`}
                                        onLoad={(e) => {
                                            e.target.style.opacity = 1;
                                        }}
                                        onError={(e) => {
                                            e.target.src = 'https://biscuitandchai-general.nyc3.cdn.digitaloceanspaces.com/biscuitandchai/image-placeholder.jpeg'
                                        }} />
                                </div>
                            </div>
                            <div tabIndex={0} aria-label={`View ${product.name} Details`} className="product-detail text-center">
                                <div className='pb-2'>
                                    <h4>{product.name}</h4>
                                    <a href={"https://blog.biscuitandchai.com"} target={"_blank"}>View Sample</a>
                                    <h6>{product.details}</h6>
                                    {product.sale_price ?
                                        <h5 style={{color: 'red'}}>
                                            On Sale {product.sale_price}
                                            <del>
                                                <span className="money">
                                                    {product.price}
                                                </span>
                                            </del>
                                        </h5>
                                        :
                                        <h5>
                                            <span className="money">
                                                {product.price}
                                            </span>
                                        </h5>
                                    }

                                    <div className="domain domain-search">
                                        <input type={"text"} placeholder={"Search For Your Domain"} onChange={onChange} value={domain}  />

                                        <button className='search-domain text-white bg-primary border-0' onClick={searchDomainAvailable}>
                                            SEARCH
                                        </button>
                                    </div>

                                    <div className="domain domain-list">

                                        <button disabled={!approvedDomain} className='add-to-cart text-white bg-primary border-0' onClick={addToCart}>
                                            ADD TO CART
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        products: state.data.products,
        cartItems: state.cartList.cart,
        cart: state.cartList.cartObj
    }
}

export default connect(
    mapStateToProps, { getOrLoginUser, logoutUser, addToCart }
)(ProductPage)
